import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1c34a30b&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\happyboxstore-repo\\shoppe\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c34a30b')) {
      api.createRecord('1c34a30b', component.options)
    } else {
      api.reload('1c34a30b', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=1c34a30b&", function () {
      api.rerender('1c34a30b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Shoppe/App.vue"
export default component.exports